import React from 'react';
import {Dimmer, Grid, Loader, Table} from 'semantic-ui-react';
import PropTypes from "prop-types";
import DataProvider from "./data-providers/data-provider";
import ExportDataProvider from "./data-providers/export-data-provider";
import CsvExportDataProvider from "./data-providers/csv-export-data-provider";
import {Observable} from "rxjs";

function Header() { return null }
function Footer() { return null }

export default class DataTableWithoutExport extends React.Component {

    static Header = Header;
    static Footer = Footer;

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: false,
            dataProvider: this.props.dataProvider,
            exportDataProvider: this.props.exportDataProvider || new CsvExportDataProvider(),
            sortSettings: {
                sort: this.props.defaultSort || '',
                order: "asc",
            }
        };
    }

    componentDidMount() {
        this.refreshData();
    }

    get getDataProviderContext() {
        const defaultContext = {
            sortSettings: this.state.sortSettings,
            name: this.props.name
        };

        if(!this.props.additionalProviderContext)
        { return defaultContext; }

        return { ...defaultContext, ...this.props.additionalProviderContext() };
    }

    getSlot(slotType) {
        const children = this.props.children || {};
        if(children.find)
        { return children.find(child => child.type === slotType); }
         return children.type === slotType ? children : null;
    }

    get headerSlot() { return this.getSlot(Header); }
    get footerSlot() { return this.getSlot(Footer); }

    get showExport() {
        return this.props.headerComponent.Layout && (typeof(this.props.canExport) === "undefined") ? true : this.props.canExport
    }

    UNSAFE_componentWillMount() {
        if(this.props.refreshDataTrigger)
        { this.props.refreshDataTrigger.subscribe(this.refreshData); }
    }

    componentWillUnmount() {
        if(this.props.refreshDataTrigger && this.props.refreshDataTrigger.unsubscribe)
        { this.props.refreshDataTrigger.unsubscribe(this.refreshData); }
    }

    onChangeSort = clickedColumn => {
        const {sort, order} = this.state.sortSettings;

        let newOrder = order === 'asc' ? 'desc' : 'asc';
        if (sort !== clickedColumn) {
            newOrder = 'asc';
        }

        const sortSettings = {sort: clickedColumn, order: newOrder};
        this.setState({sortSettings}, this.refreshData);
    };

    refreshData = () => {
        const loadingTimeout = setTimeout(() => {
            this.setState({isLoading: true});
        }, 500);

        return this.state.dataProvider
            .refreshData(this.getDataProviderContext)
            .then((data) => {
                clearTimeout(loadingTimeout);
                this.setState({data: data.elements, isLoading: false });
                if(this.props.onTableRefreshed)
                { this.props.onTableRefreshed(data); }
            });
    };

    exportData = () => {
        this.state.exportDataProvider
            .exportData(this.state.dataProvider, this.props.headerComponent.Layout, this.getDataProviderContext);
    };

    render() {
        const HeaderTag = this.props.headerComponent;
        const RowTag = this.props.rowComponent;
        const rowContent = this.state.data.map((element, index) => (
            <RowTag key={index} data={element} contextData={this.props.contextData}/>
        ));

        return (
            <React.Fragment>
                <div className="data-table">
                    <Dimmer active={this.state.isLoading}>
                        <Loader indeterminate>Refreshing Table</Loader>
                    </Dimmer>
                    <Grid stackable columns='equal'>
                        <Grid.Row>
                            <Grid.Column>
                                {!!this.headerSlot && this.headerSlot.props.children}
                            </Grid.Column>
                            {this.showExport &&
                             <Grid.Column floated='right' width={3}>
                                {/* <Button compact floated='right' color='orange' onClick={this.exportData}>Export Data</Button>
                        */}
                             </Grid.Column>}
                        </Grid.Row>
                    </Grid>
                    <Table striped padded selectable sortable>
                        <HeaderTag
                            column={this.state.sortSettings.sort}
                            contextData={this.props.contextData}
                            direction={this.state.sortSettings.order}
                            onChangeSort={this.onChangeSort}
                        />
                        <Table.Body>
                            {(this.state.data.length === 0) ? <React.Fragment/> : rowContent}
                        </Table.Body>
                        {!!this.footerSlot && this.footerSlot.props.children}
                    </Table>
                </div>
            </React.Fragment>
        );
    }
}

DataTableWithoutExport.propTypes = {
    dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
    headerComponent: PropTypes.elementType.isRequired,
    rowComponent: PropTypes.elementType.isRequired,
    refreshDataTrigger: PropTypes.instanceOf(Observable),
    exportDataProvider: PropTypes.instanceOf(ExportDataProvider),
    onTableRefreshed: PropTypes.func,
    defaultSort: PropTypes.string,
    additionalProviderContext: PropTypes.func,
    name: PropTypes.string,
    canExport: PropTypes.bool,
    contextData: PropTypes.any
};

